import React from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';
import CorrelativesAdminTableSection from '../../components/settings/CorrelativesAdmin/CorrelativesAdminTableSection';

/**
 * 🔢 CorrelativesAdminPage
 *
 * Página de administración de correlativos.
 * Permite ejecutar acciones manuales y visualizar
 * el estado general de las secuencias de documentos.
 */
const CorrelativesAdminPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <div className="space-y-6 p-6">
          {/* 🧭 Título */}
          <div>
            <h2 className="text-xl font-semibold text-black dark:text-white">
              Administración de Correlativos
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mt-1">
              Desde esta sección puede ejecutar acciones administrativas sobre
              los correlativos de documentos, como su restablecimiento
              controlado y la verificación de su estado actual.
            </p>
          </div>
        </div>
        <CorrelativesAdminTableSection />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default CorrelativesAdminPage;
